export default __webpack_public_path__ + "static/media/fail.d4ce2a26.svg";